import { PageHeader } from "@sylviq/ui-react-web/components/ui/page-header";
import { Tabs } from "@sylviq/ui-react-web/components/ui/tabs";
import { useViewSearch } from "@/lib/view-search";
import { FixedAssetsPage } from "./FixedAssetsPage";
import { LoansPage } from "@/features/loans/LoansPage";

const TABS = [
  { value: "fixed-assets", label: "Fixed assets" },
  { value: "loans", label: "Loans" },
];

export function AssetsAndLoansPage() {
  const [tab, setTab] = useViewSearch(
    "tab",
    TABS.map((item) => item.value),
    "fixed-assets",
  );
  return (
    <div className="grid gap-6">
      <PageHeader
        title="Assets & loans"
        description="Fixed-asset registers and repayment schedules — the subledgers behind the balance sheet."
      />
      <Tabs
        tabs={TABS}
        value={tab}
        onValueChange={setTab}
        label="Assets and loans sections"
      >
        {tab === "loans" ? <LoansPage embedded /> : <FixedAssetsPage embedded />}
      </Tabs>
    </div>
  );
}
